// @flow
export function setCurrency(currency: ?string) {
  return {
    type: "SET_CURRENCY",
    currency,
  }
}

export function setOption(option: string, value: any) {
  return {
    type: "SET_OPTION",
    option,
    value,
  }
}

export function toggleOption(option: string) {
  return {
    type: "TOGGLE_OPTION",
    option,
  }
}

export function switchABVersion(slot: string) {
  return {
    type: "SWITCH_AB_VERSION",
    slot,
  }
}

export function setCustomerVerified(verified: boolean) {
  return {
    type: "SET_CUSTOMER_VERIFIED",
    verified,
  }
}
